// extracted by mini-css-extract-plugin
export default {"mottoList":"MottoSection_mottoList__Yg99M","mottoListItem":"MottoSection_mottoListItem__K7yzN"};